// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c646a474","126":"63cf7baa","171":"871b03ec","388":"a5507d4e","453":"5a15883a"}[chunkId] + ".chunk.js";
};